import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import * as AuthenticationSelectors from "@app/shared/state/authentication/authentication.selectors";
import { Constants } from "../../../constants/constants";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CustomPromotionsGuard {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.store
      .select(
        AuthenticationSelectors.selectDoesUserHaveAnyAction([
          Constants.UserActions.CustomPromotionsRead,
          Constants.UserActions.CustomPromotionsCreate,
          Constants.UserActions.CustomPromotionsDelete,
          Constants.UserActions.CustomPromotionsFinalize,
          Constants.UserActions.CustomPromotionsUpdate,
          Constants.UserActions.CustomPromotionsAdminUpdate,
          Constants.UserActions.CustomPromotionsAdminRead,
          Constants.UserActions.CustomPromotionsItAdmin,
        ]),
      )
      .pipe(
        map(
          (hasSiteAccess) =>
            hasSiteAccess || this.router.parseUrl("/unauthorized"),
        ),
      );
  }
}
